import { render, staticRenderFns } from "./otherPlatform.vue?vue&type=template&id=51abb736&scoped=true"
import script from "./otherPlatform.vue?vue&type=script&lang=js"
export * from "./otherPlatform.vue?vue&type=script&lang=js"
import style0 from "./otherPlatform.vue?vue&type=style&index=0&id=51abb736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51abb736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51abb736')) {
      api.createRecord('51abb736', component.options)
    } else {
      api.reload('51abb736', component.options)
    }
    module.hot.accept("./otherPlatform.vue?vue&type=template&id=51abb736&scoped=true", function () {
      api.rerender('51abb736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/otherPlatform.vue"
export default component.exports